import { Modal } from "@drone-js/core";
import { useStaticDataAtomValue } from "apps/oneOnboarding/staticDataAtom";
import type { FunctionComponent } from "react";

interface Props {
    open: boolean;
    onAcknowledge: () => void;
}

export const PropertyLicenseRequiredModal: FunctionComponent<Props> = ({ open, onAcknowledge }) => {
    const {
        cmsData: {
            publish: { needLicenseForOneProperty, enterLicenseToContinue, addLicense },
        },
    } = useStaticDataAtomValue();

    return (
        <Modal
            visible={open}
            onClose={onAcknowledge}
            title={needLicenseForOneProperty}
            description={enterLicenseToContinue}
            size="m"
            actions={[
                {
                    actionType: "button",
                    variant: "label",
                    hierarchy: "primary",
                    label: addLicense,
                    onClick: onAcknowledge,
                },
            ]}
        />
    );
};
